import { yupResolver } from '@hookform/resolvers/yup';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import { useAppDispatch } from '../../hooks/hooks';
import { resetUpdateTeacherRequiredDocumentData } from '../../redux/slices/school/teacherRequiredDocument';
import { RootState } from '../../redux/store';
import { routes } from '../../routes';
import { updateTeacherRequiredDocument } from '../../services/school/teacher/updateTeacherRequiredDocument';
import { RulesDocumentTeacherType } from '../../types/Teacher';
import { Key_teacherRequiredDocuments } from '../../utils/constants';
import { UpdateTeacherRequiredDocumentFormValidation } from './UpdateTeacherRequiredDocumentFormValidation';

export default function UpdateTeacherRequiredDocument() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const mutation = useMutation({ mutationFn: updateTeacherRequiredDocument, mutationKey: "updateTeacherRequiredDocument" })
  const UpdateFormData = useSelector((state: RootState) => state.teacherRequiredDocument);
  const queryClient = useQueryClient();

  const { control, handleSubmit, formState: { errors }, reset } = useForm<RulesDocumentTeacherType>({
    resolver: yupResolver(UpdateTeacherRequiredDocumentFormValidation),
    defaultValues: UpdateFormData,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  })
  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success('Tipo de documento actualizado');
        queryClient.invalidateQueries(Key_teacherRequiredDocuments);
        navigate(routes.teacherRequiredDocuments);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleBack = (e: any) => {
    dispatch(resetUpdateTeacherRequiredDocumentData());
    navigate(routes.teacherRequiredDocuments);
  }
  return (

    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
          
          <TextFieldComponent control={control} errors={errors} label='Tipo de documento' name='description' required={true} />

          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button color='red' onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}